import { useEffect } from 'react'
import qrcodeWxImage from '../assets/qrcode_for_wx.jpg'
import qrcodeKadaImage from '../assets/qrcode_for_kada.jpg'

export type WechatQRCodeVariant = 'landing' | 'auth'

interface WechatQRCodeModalProps {
  open: boolean
  onClose: () => void
  variant?: WechatQRCodeVariant
}

interface QRCodeItem {
  id: string
  title: string
  subtitle: string
  image: string
  alt: string
}

const QR_CODES: QRCodeItem[] = [
  {
    id: 'wx',
    title: '二进制茶馆',
    subtitle: '个人公众号 · 邀请码 & 技术分析',
    image: qrcodeWxImage,
    alt: '二进制茶馆 微信公众号 二维码',
  },
  {
    id: 'kada',
    title: 'KADA Lab',
    subtitle: '服务号 · 邀请码 & 产品动态',
    image: qrcodeKadaImage,
    alt: 'KADA Lab 微信服务号 二维码',
  },
]

export function WechatQRCodeModal({ open, onClose, variant = 'landing' }: WechatQRCodeModalProps) {
  useEffect(() => {
    if (!open) return
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', handleKey)
    return () => window.removeEventListener('keydown', handleKey)
  }, [open, onClose])

  if (!open) return null

  const isLanding = variant === 'landing'

  const surfaceStyle = isLanding
    ? { backgroundColor: 'var(--lp-surface)' }
    : { backgroundColor: '#FFFFFF' }
  const titleColor = isLanding ? 'var(--lp-text)' : '#37352F'
  const subtitleColor = isLanding ? 'var(--lp-text-2)' : '#787774'
  const captionColor = isLanding ? 'var(--lp-text-3)' : '#9D9D9B'
  const borderColor = isLanding ? 'var(--lp-border)' : '#E3E2E0'

  return (
    <div
      className="fixed inset-0 z-[80] bg-black/50 flex items-center justify-center p-4 animate-fade-in"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="关注 FlowMore 微信公众号"
    >
      <div
        className="rounded-2xl p-6 md:p-7 max-w-xl w-full shadow-2xl relative animate-slide-in transition-colors duration-500"
        style={surfaceStyle}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute top-4 right-4 transition-colors"
          style={{ color: subtitleColor }}
          aria-label="关闭"
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>

        <div className="text-center mb-5">
          <h3 className="text-lg font-semibold" style={{ color: titleColor }}>关注我们的微信公众号</h3>
          <p className="text-xs mt-1" style={{ color: subtitleColor }}>
            扫描下方任一二维码，即可关注
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {QR_CODES.map((qr) => (
            <div
              key={qr.id}
              className="flex flex-col items-center text-center rounded-xl border p-4 transition-colors duration-500"
              style={{ borderColor }}
            >
              <img
                src={qr.image}
                alt={qr.alt}
                className="w-40 h-40 object-contain rounded-lg border"
                style={{ borderColor }}
              />
              <p className="mt-3 text-sm font-semibold" style={{ color: titleColor }}>{qr.title}</p>
              <p className="mt-1 text-xs leading-relaxed" style={{ color: subtitleColor }}>
                {qr.subtitle}
              </p>
            </div>
          ))}
        </div>

        <p className="mt-4 text-center text-[11px]" style={{ color: captionColor }}>
          个人号分享创作过程，服务号同步产品最新进展
        </p>
      </div>
    </div>
  )
}
